import {default as _} from 'lodash';
import { Component, OnInit, ViewChild } from '@angular/core';
import {default as GridColumnsJSON} from 'app/Shared/Constant/Grid Column Names/Market-access-Columns.json';
import { APIURL } from 'app/Shared/Constant/API_Urls';
import { GridService } from 'app/Shared/Services/grid.service';
import { HttpErrorResponse } from '@angular/common/http';
import { EmitterService } from 'app/Shared/Services/emitter.service';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { Table, TableModule  } from "primeng/table";
import { MarketAccess } from './market-access.model';
import { SharedHttpClientService } from 'app/Shared/Services/shared-http-client.service';
import { UrlsService } from 'app/Shared/Services/urls.service';
import { UserService } from 'app/Shared/Services/user.service';
import { MessageService } from 'primeng/api';
import { DataService } from 'app/Shared/Services/data.service';
import { SortPipe } from 'app/Shared/Component/pipes/sort.pipe';
import { generateCsv, asBlob } from "export-to-csv";
import { saveAs } from 'file-saver';
import { FilterPanelComponent } from 'app/Shared/Component/filter-panel/filter-panel.component';
import { CommonModule, LowerCasePipe, NgClass } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MultiSelectModule } from 'primeng/multiselect';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ExportToCSVSComponent } from 'app/Shared/Component/export-to-csv/export-to-csv.component';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { DrawerModule } from 'primeng/drawer';

@Component({
    selector: 'app-market-access',
    imports: [TableModule, FilterPanelComponent, CommonModule, MatProgressSpinner, NgClass, MultiSelectModule, DrawerModule,
        MatTooltipModule, LowerCasePipe, ExportToCSVSComponent, FormsModule, ButtonModule, ToastModule],
    templateUrl: './market-access.component.html',
    styleUrls: ['./market-access.component.scss']
})
export class MarketAccessComponent implements OnInit {
  @ViewChild(('dt')) dt!: Table;
  GridColumns = GridColumnsJSON;
  dataset: MarketAccess[] = [];
  selectedRow: MarketAccess = new MarketAccess();
  isLoadingResults: boolean = true;
  isLoadingDestinationResults: boolean = true;
  isLoadingCustomerResults: boolean = true;
  isLoadingTraderResults: boolean = true;
  isLoadingPriceDeviationResults: boolean = true;
  isLoadingMaxOrderQty30DayAdvResults: boolean = true;
  isLoadingGrossNotionalResults: boolean = true;
  isApiRecalling: boolean = true;
  tbldatamsg: string = "L o a d i n g . . . . .";
  totalRecords!: number;
  Limit: any = { 'Start': '', 'End': '' };
  previousLimit: any = { 'Start': '', 'End': '' };
  defaultFilterArray: any = [];
  startLimit: any = 0;
  endLimit!: number;
  rowcount!: number;
  columnJson: any = [];
  cols: any = [];
  priviousStartLimit: any;
  pageNumber: any = 1;
  sortData:any = { field: '', order: 0};
  sortClickCounter: number = 0;
  LastExecutionDate: any = '';
  orderDateRange: any = '';
  routeDateRange: any = '';
  tblColBgColor: string = '';
  rowDataforDialog: any;
  rowIndexForDialog!: number;
  actionType!: string;
  recordSummaryType: number = 1;
  /* Variable Initialization */
    qtyField: string  = 'quantity';
    notionalField: string = 'notionalamount';
    destinationSortField: number = 0;
    destinationQtyFieldSortOrder: boolean |"asc"|"desc"|"" = 'desc';
    destinationNotionalFieldSortOrder: boolean |"asc"|"desc"|"" = '';
    customerSortField: number = 0;
    customerQtyFieldSortOrder: boolean |"asc"|"desc"|"" = 'desc';
    customerNotionalFieldSortOrder: boolean |"asc"|"desc"|"" = '';
    traderSortField: number = 0;
    traderQtyFieldSortOrder: boolean |"asc"|"desc"|"" = 'desc';
    traderNotionalFieldSortOrder: boolean |"asc"|"desc"|"" = '';

    routeBuyField: string = 'routeBuy';
    routeSellField: string = 'routeSell';
    orderBuyField: string = 'orderBuy';
    orderSellField: string = 'orderSell';
    PDPercentage: string = 'PD_Percentage';
    priceDeviationSortField: number = 0;
    routeBuyFieldSortOrder: boolean |"asc"|"desc"|"" = 'desc';
    routeSellFieldSortOrder: boolean |"asc"|"desc"|"" = '';
    orderBuyFieldSortOrder: boolean |"asc"|"desc"|"" = '';
    orderSellFieldSortOrder: boolean |"asc"|"desc"|"" = '';

    maxOrderQtyField: string  = 'totalQuantities';
    maxOrderQtyFieldSortOrder: boolean |"asc"|"desc" = 'desc';

    notionalBuyOpenField: string = 'buyOpened';
    notionalSellOpenField: string = 'sellOpened';
    notionalBuyExecutedField: string = 'buyExecuted';
    notionalSellExecutedField: string = 'sellExecuted';
    notionalSortField: number = 0;
    notionalBuyOpenFieldSortOrder: boolean |"asc"|"desc"|"" = 'desc';
    notionalSellOpenFieldSortOrder: boolean |"asc"|"desc"|"" = '';
    notionalBuyExecutedFieldSortOrder: boolean |"asc"|"desc"|"" = '';
    notionalSellExecutedFieldSortOrder: boolean |"asc"|"desc"|"" = '';

    maxQtyData: any[] = [];
    destinationDetailRows: any;
    destinationDetail!: any[];

    customerMaxQtyData: any[] = [];
    customerDetailRows: any;
    customerDetail!: any[];

    traderMaxQtyData: any[] = [];
    traderDetailRows: any;
    traderDetail!: any[];

    maxPriceDeviationData: { [key: string]: any[] } = {};;
    priceDeviationDetail!: any[];

    maxSymbolOrderQtyData!: any[];
    maxSymbolOrderQtyDetail!: any[];

    maxGrossNotionalData!: any[];
    grossNotionalDetail!: any[];

    frozenCols!: any[];
    scrollableCols!: any[];
    optedDestinations!: any[];

    frozenCustomerCols!: any[];
    scrollableCustomerCols!: any[];
    optedCustomers!: any[];

    frozenTraderCols!: any[];
    scrollableTraderCols!: any[];
    optedTraders!: any[];

    frozenPriceDeviationCols!: any[];
    scrollablePriceDeviationCols!: any[];

    frozenMaxOrderSymbolQtyCols!: any[];
    scrollableMaxOrderSymbolQtyCols!: any[];

    frozenNotionalCols!: any[];
    scrollableNotionalCols!: any[];

    loading!: boolean;
    view!: boolean;
    maxPriceDeviationTable: boolean = false;
    maxOrderQty30DayAdvTable: boolean = false;
    maxDailyGrossNotionalTable: boolean = false;
  /* End of Variable Initialization */

  constructor(private gridService: GridService,
    public constantService: ConstantService,
    private sharedHttpClientService: SharedHttpClientService,
    private urlsService: UrlsService,
    private messageService: MessageService,
    private emitterService: EmitterService,
    private userService: UserService,
    public dataService: DataService,
    private sortPipe: SortPipe) {
  }

  ngOnInit() {
    this.loading = true;

    // Here is the problem only frozing First Column
    this.frozenCols = [{ field: 'Destination', header: 'Destination' }];

    this.frozenCustomerCols = [{ field: 'Customer', header: 'Customer' }];

    this.frozenTraderCols = [{ field: 'Trader', header: 'Trader' }];

    this.frozenPriceDeviationCols = [{ field: 'Route', header: '' }, { field: 'Orders', header: '' }];

    this.frozenMaxOrderSymbolQtyCols = [{ field: 'Symbol', header: 'Symbol' }];

    this.frozenNotionalCols = [{ field: 'Gross_Notional', header: 'Customer' }];

    this.destinationDetail = [
      { Destination: "Quantity" },
      { Destination: "Notional" }
    ];

    this.customerDetail = [
      { Customer: "Quantity" },
      { Customer: "Notional" }
    ];

    this.traderDetail = [
      { Trader: "Quantity" },
      { Trader: "Notional" }
    ];

    this.priceDeviationDetail = [
      { Route: 'Route', Orders: 'Buy Orders' },
      { Route: 'Route', Orders: 'Sell Orders' },
      { Route: 'Order', Orders: 'Buy Orders' },
      { Route: 'Order', Orders: 'Sell Orders' }
    ];

    this.maxSymbolOrderQtyDetail = [{ Symbol: 'Buy and Sell Orders' }];

    this.grossNotionalDetail = [
      { Gross_Notional: 'Buy Open' },
      { Gross_Notional: 'Sell Open' },
      { Gross_Notional: 'Buy Executed' },
      { Gross_Notional: 'Sell Executed' }
    ];

    this.getDefaultValues('Destination');
    this.getDefaultValues('Customer');
    this.getDefaultValues('Trader');
    this.getDefaultValues('Price Deviation');
    this.getDefaultValues('Maximum Order Quantity 30 Day ADV');
    this.getDefaultValues('Gross Notional');

    /* Summary Table Initialization */
      this.rowcount = this.constantService.DEFAULT_ROWSIZE;
      this.endLimit = this.rowcount;
      this.Limit = { 'Start': '0', 'End': this.endLimit };
      this.totalRecords = this.rowcount;
      this.defaultFilter();
      this.getColumns();
      this.getData();

      /* MultiSelect Destinations|Customers|Traders */
      this.optedDestinations = this.scrollableCols;
      this.optedCustomers = this.scrollableCustomerCols;
      this.optedTraders = this.scrollableTraderCols;
  }

  getColumns() {
    let column: any = this.GridColumns;
    this.columnJson = [];
    if (column != null || column != undefined) {
      this.columnJson = this.gridService.getGridColumns(column);
      this.cols = this.gridService.getGridColumns(column);
    }
  }

  getMarketAccessData(recordSummary: number, recordSummaryText: string) {
    this.maxPriceDeviationTable = (recordSummaryText.includes('Maximum Price Deviation') ? true : false);
    this.maxOrderQty30DayAdvTable = (recordSummaryText.includes('Maximum Order Quantity of 30 Day ADV') ? true : false);
    this.maxDailyGrossNotionalTable = (recordSummaryText.includes('Maximum Gross Notional') ? true : false);
    this.recordSummaryType = recordSummary;
    if(!this.maxOrderQty30DayAdvTable && !this.maxDailyGrossNotionalTable) {
      this.endLimit = this.rowcount;
      this.Limit = { 'Start': '0', 'End': this.endLimit };
      this.totalRecords = this.rowcount;
      this.getData();
    }
  }

  getFilterData(data: any, resType: string) {
    if(resType.search("Destination") !== -1) {
      this.optedDestinations = this.getSortedOptedItems(this.scrollableCols, this.optedDestinations);
    } else if(resType.search("Customer") !== -1) {
      this.optedCustomers = this.getSortedOptedItems(this.scrollableCustomerCols, this.optedCustomers);
    } else if(resType.search("Trader") !== -1) {
      this.optedTraders = this.getSortedOptedItems(this.scrollableTraderCols, this.optedTraders);
    }
  }

  getSortedOptedItems(scrollableItems: any, optedItems: any) {
    let sortedOptedItems = [];
      for(let i=0; i<scrollableItems.length; i++) {
        for(let j=0;j<optedItems.length;j++) {
          if(scrollableItems[i].header === optedItems[j].header) {
            sortedOptedItems.push(scrollableItems[i]);
            break;
          }
        }
      }
      return sortedOptedItems;
  }

  fieldSort(resType: string, recordType: number) {
    if(resType.search("Destination") !== -1) {
      this.sortDestinations(recordType);
    } else if(resType.search("Customer") !== -1) {
      this.sortCustomers(recordType);
    } else if(resType.search("Trader") !== -1) {
      this.sortTraders(recordType);
    } else if(resType.search("Price_Deviation") !== -1) {
      this.sortPriceDeviations(recordType);
    } else if(resType.search("Symbol") !== -1) {
      this.sortSymbols();
    } else if(resType.search("Gross_Notional") !== -1) {
      this.sortGrossNotionals(recordType);
    }
  }

  sortDestinations(recordType: number) {
    switch(recordType) {
      case 0:
        this.destinationSortField = 0;
        this.destinationNotionalFieldSortOrder = '';
        this.destinationQtyFieldSortOrder = (this.destinationQtyFieldSortOrder === 'desc' ? 'asc' : 'desc');
        this.maxQtyData = _.orderBy(this.maxQtyData, [this.qtyField], [this.destinationQtyFieldSortOrder]);
      break;
      case 1:
        this.destinationSortField = 1;
        this.destinationQtyFieldSortOrder = '';
        this.destinationNotionalFieldSortOrder = (this.destinationNotionalFieldSortOrder === 'desc' ? 'asc' : 'desc');
        this.maxQtyData = _.orderBy(this.maxQtyData, [this.notionalField], [this.destinationNotionalFieldSortOrder]);
      break;
    }
    if(this.maxQtyData.length > 0) {
      this.scrollableCols = [];
      for(let i=0; i<this.maxQtyData.length; i++) {
        this.scrollableCols.push({ field: 'Destination ' + i, header: this.maxQtyData[i].destination.substring(this.maxQtyData[i].destination.indexOf(":")+1) });
        this.destinationDetail[0]['Destination ' + i] = this.maxQtyData[i].quantity.toLocaleString("en-US");
        this.destinationDetail[1]['Destination ' + i] = this.maxQtyData[i].notionalamount.toLocaleString("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 0, maximumFractionDigits: 0 });
      }
      /* MultiSelect Destinations */
      this.optedDestinations = this.getSortedOptedItems(this.scrollableCols, this.optedDestinations);
    }
  }

  sortCustomers(recordType: number) {
    switch(recordType) {
      case 0:
        this.customerSortField = 0;
        this.customerNotionalFieldSortOrder = '';
        this.customerQtyFieldSortOrder = (this.customerQtyFieldSortOrder === 'desc' ? 'asc' : 'desc');
        this.customerMaxQtyData = _.orderBy(this.customerMaxQtyData, [this.qtyField], [this.customerQtyFieldSortOrder]);
      break;
      case 1:
        this.customerSortField = 1;
        this.customerQtyFieldSortOrder = '';
        this.customerNotionalFieldSortOrder = (this.customerNotionalFieldSortOrder === 'desc' ? 'asc' : 'desc');
        this.customerMaxQtyData = _.orderBy(this.customerMaxQtyData, [this.notionalField], [this.customerNotionalFieldSortOrder]);
      break;
    }
    if(this.customerMaxQtyData.length > 0) {
      this.scrollableCustomerCols = [];
      for(let i=0; i<this.customerMaxQtyData.length; i++) {
        this.scrollableCustomerCols.push({ field: 'Customer ' + i, header: this.customerMaxQtyData[i].customer });
        this.customerDetail[0]['Customer ' + i] = this.customerMaxQtyData[i].quantity.toLocaleString("en-US");
        this.customerDetail[1]['Customer ' + i] = this.customerMaxQtyData[i].notionalamount.toLocaleString("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 0, maximumFractionDigits: 0 });
      }
      /* MultiSelect Customers */
      this.optedCustomers = this.getSortedOptedItems(this.scrollableCustomerCols, this.optedCustomers);
    }
  }

  sortTraders(recordType: number) {
    switch(recordType) {
      case 0:
        this.traderSortField = 0;
        this.traderNotionalFieldSortOrder = '';
        this.traderQtyFieldSortOrder = (this.traderQtyFieldSortOrder === 'desc' ? 'asc' : 'desc');
        this.traderMaxQtyData = _.orderBy(this.traderMaxQtyData, [this.qtyField], [this.traderQtyFieldSortOrder]);
      break;
      case 1:
        this.traderSortField = 1;
        this.traderQtyFieldSortOrder = '';
        this.traderNotionalFieldSortOrder = (this.traderNotionalFieldSortOrder === 'desc' ? 'asc' : 'desc');
        this.traderMaxQtyData = _.orderBy(this.traderMaxQtyData, [this.notionalField], [this.traderNotionalFieldSortOrder]);
      break;
    }
    if(this.traderMaxQtyData.length > 0) {
      this.scrollableTraderCols = [];
      for(let i=0; i<this.traderMaxQtyData.length; i++) {
        this.scrollableTraderCols.push({ field: 'Trader ' + i, header: this.traderMaxQtyData[i].trader });
        this.traderDetail[0]['Trader ' + i] = this.traderMaxQtyData[i].quantity.toLocaleString("en-US");
        this.traderDetail[1]['Trader ' + i] = this.traderMaxQtyData[i].notionalamount.toLocaleString("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 0, maximumFractionDigits: 0 });
      }
      /* MultiSelect Traders */
      this.optedTraders = this.getSortedOptedItems(this.scrollableTraderCols, this.optedTraders);
    }
  }

  sortPriceDeviations(recordType: number) {
    switch(recordType) {
      case 0:
        this.priceDeviationSortField = 0;
        this.routeSellFieldSortOrder = '';
        this.orderBuyFieldSortOrder = '';
        this.orderSellFieldSortOrder = '';
        this.routeBuyFieldSortOrder = (this.routeBuyFieldSortOrder === 'desc' ? 'asc' : 'desc');
        this.maxPriceDeviationData[this.routeBuyField] = _.orderBy(this.maxPriceDeviationData[this.routeBuyField], [this.PDPercentage], [this.routeBuyFieldSortOrder]);
      break;
      case 1:
        this.priceDeviationSortField = 1;
        this.routeBuyFieldSortOrder = '';
        this.orderBuyFieldSortOrder = '';
        this.orderSellFieldSortOrder = '';
        this.routeSellFieldSortOrder = (this.routeSellFieldSortOrder === 'desc' ? 'asc' : 'desc');
        this.maxPriceDeviationData[this.routeSellField] = _.orderBy(this.maxPriceDeviationData[this.routeSellField], [this.PDPercentage], [this.routeSellFieldSortOrder]);
      break;
      case 2:
        this.priceDeviationSortField = 2;
        this.routeBuyFieldSortOrder = '';
        this.routeSellFieldSortOrder = '';
        this.orderSellFieldSortOrder = '';
        this.orderBuyFieldSortOrder = (this.orderBuyFieldSortOrder === 'desc' ? 'asc' : 'desc');
        this.maxPriceDeviationData[this.orderBuyField] = _.orderBy(this.maxPriceDeviationData[this.orderBuyField], [this.PDPercentage], [this.orderBuyFieldSortOrder]);
      break;
      case 3:
        this.priceDeviationSortField = 3;
        this.routeBuyFieldSortOrder = '';
        this.routeSellFieldSortOrder = '';
        this.orderBuyFieldSortOrder = '';
        this.orderSellFieldSortOrder = (this.orderSellFieldSortOrder === 'desc' ? 'asc' : 'desc');
        this.maxPriceDeviationData[this.orderSellField] = _.orderBy(this.maxPriceDeviationData[this.orderSellField], [this.PDPercentage], [this.orderSellFieldSortOrder]);
      break;
    }
    if(Object.keys(this.maxPriceDeviationData).length > 0) {
      this.scrollablePriceDeviationCols = [];
      for(let i=0; i<this.maxPriceDeviationData[this.routeBuyField].length; i++) {
        this.scrollablePriceDeviationCols.push({ field: 'Price_Deviation ' + i, header: '' });
        this.priceDeviationDetail[0]['Price_Deviation ' + i] = Number.parseFloat(this.maxPriceDeviationData[this.routeBuyField][i][this.PDPercentage] ? this.maxPriceDeviationData[this.routeBuyField][i][this.PDPercentage] : 0) + '%';
        this.priceDeviationDetail[1]['Price_Deviation ' + i] = Number.parseFloat(this.maxPriceDeviationData[this.routeSellField][i][this.PDPercentage] ? this.maxPriceDeviationData[this.routeSellField][i][this.PDPercentage] : 0) + '%';
        this.priceDeviationDetail[2]['Price_Deviation ' + i] = Number.parseFloat(this.maxPriceDeviationData[this.orderBuyField][i][this.PDPercentage] ? this.maxPriceDeviationData[this.orderBuyField][i][this.PDPercentage] : 0) + '%';
        this.priceDeviationDetail[3]['Price_Deviation ' + i] = Number.parseFloat(this.maxPriceDeviationData[this.orderSellField][i][this.PDPercentage] ? this.maxPriceDeviationData[this.orderSellField][i][this.PDPercentage] : 0) + '%';
      }
    }
  }

  sortSymbols() {
    this.maxOrderQtyFieldSortOrder = (this.maxOrderQtyFieldSortOrder === 'desc' ? 'asc' : 'desc');
    this.maxSymbolOrderQtyData = _.orderBy(this.maxSymbolOrderQtyData, [this.maxOrderQtyField], [this.maxOrderQtyFieldSortOrder]);
    if(this.maxSymbolOrderQtyData.length > 0) {
      this.scrollableMaxOrderSymbolQtyCols = [];
      for(let i=0; i<this.maxSymbolOrderQtyData.length; i++) {
        this.scrollableMaxOrderSymbolQtyCols.push({ field: 'Symbol ' + i, header: this.maxSymbolOrderQtyData[i]['Symbol'] });
          this.maxSymbolOrderQtyDetail[0]['Symbol ' + i] = this.maxSymbolOrderQtyData[i]['totalQuantities'].toLocaleString("en-US");
      }
    }
  }

  sortGrossNotionals(recordType: number) {
    switch(recordType) {
      case 0:
        this.notionalSortField = 0;
        this.notionalSellOpenFieldSortOrder = '';
        this.notionalBuyExecutedFieldSortOrder = '';
        this.notionalSellExecutedFieldSortOrder = '';
        this.notionalBuyOpenFieldSortOrder = (this.notionalBuyOpenFieldSortOrder === 'desc' ? 'asc' : 'desc');
        this.maxGrossNotionalData = _.orderBy(this.maxGrossNotionalData, [this.notionalBuyOpenField], [this.notionalBuyOpenFieldSortOrder]);
      break;
      case 1:
        this.notionalSortField = 1;
        this.notionalBuyOpenFieldSortOrder = '';
        this.notionalBuyExecutedFieldSortOrder = '';
        this.notionalSellExecutedFieldSortOrder = '';
        this.notionalSellOpenFieldSortOrder = (this.notionalSellOpenFieldSortOrder === 'desc' ? 'asc' : 'desc');
        this.maxGrossNotionalData = _.orderBy(this.maxGrossNotionalData, [this.notionalSellOpenField], [this.notionalSellOpenFieldSortOrder]);
      break;
      case 2:
        this.notionalSortField = 2;
        this.notionalBuyOpenFieldSortOrder = '';
        this.notionalSellOpenFieldSortOrder = '';
        this.notionalSellExecutedFieldSortOrder = '';
        this.notionalBuyExecutedFieldSortOrder = (this.notionalBuyExecutedFieldSortOrder === 'desc' ? 'asc' : 'desc');
        this.maxGrossNotionalData = _.orderBy(this.maxGrossNotionalData, [this.notionalBuyExecutedField], [this.notionalBuyExecutedFieldSortOrder]);
      break;
      case 3:
        this.notionalSortField = 3;
        this.notionalBuyOpenFieldSortOrder = '';
        this.notionalSellOpenFieldSortOrder = '';
        this.notionalBuyExecutedFieldSortOrder = '';
        this.notionalSellExecutedFieldSortOrder = (this.notionalSellExecutedFieldSortOrder === 'desc' ? 'asc' : 'desc');
        this.maxGrossNotionalData = _.orderBy(this.maxGrossNotionalData, [this.notionalSellExecutedField], [this.notionalSellExecutedFieldSortOrder]);
      break;
    }
    if(this.maxGrossNotionalData.length > 0) {
      this.scrollableNotionalCols = [];
      for(let i=0; i<this.maxGrossNotionalData.length; i++) {
        this.scrollableNotionalCols.push({ field: 'Gross_Notional ' + i, header: this.maxGrossNotionalData[i].customer });
        this.grossNotionalDetail[0]['Gross_Notional ' + i] = (this.maxGrossNotionalData[i].buyOpened ? this.maxGrossNotionalData[i].buyOpened : 0).toLocaleString("en", { style: "currency", currency: "USD", minimumFractionDigits: 0, maximumFractionDigits: 0 });
        this.grossNotionalDetail[1]['Gross_Notional ' + i] = (this.maxGrossNotionalData[i].sellOpened ? this.maxGrossNotionalData[i].sellOpened : 0).toLocaleString("en", { style: "currency", currency: "USD", minimumFractionDigits: 0, maximumFractionDigits: 0 });
        this.grossNotionalDetail[2]['Gross_Notional ' + i] = (this.maxGrossNotionalData[i].buyExecuted ? this.maxGrossNotionalData[i].buyExecuted : 0).toLocaleString("en", { style: "currency", currency: "USD", minimumFractionDigits: 0, maximumFractionDigits: 0 });
        this.grossNotionalDetail[3]['Gross_Notional ' + i] = (this.maxGrossNotionalData[i].sellExecuted ? this.maxGrossNotionalData[i].sellExecuted : 0).toLocaleString("en", { style: "currency", currency: "USD", minimumFractionDigits: 0, maximumFractionDigits: 0 });
      }
    }
  }

  onRowActionSelect(value: string, fieldType: string, rowIndex: number, ColHeader: string) {
    if (value == 'View') {
      let rowData;
      switch(fieldType) {
        case 'Destination':
          switch(rowIndex) {
            case 0:
              rowData = this.destinationDetailRows['maxQuantityData'].filter((item: { destination: string | string[]; }) => item.destination.includes(ColHeader));
              if(!rowData.length) {
                rowData = this.destinationDetailRows['maxNotionalAmountData'].filter((item: { destination: string | string[]; }) => item.destination.includes(ColHeader));
              }
            break;
            case 1:
              rowData = this.destinationDetailRows['maxNotionalAmountData'].filter((item: { destination: string | string[]; }) => item.destination.includes(ColHeader));
              if(!rowData.length) {
                rowData = this.destinationDetailRows['maxQuantityData'].filter((item: { destination: string | string[]; }) => item.destination.includes(ColHeader));
              }
            break;
          }
        break;
        case 'Customer':
          switch(rowIndex) {
            case 0:
              rowData = this.customerDetailRows['customerMaxQuantityData'].filter((item: { customer: string; }) => item.customer === ColHeader);
              if(!rowData.length) {
                rowData = this.customerDetailRows['customerMaxNotionalAmountData'].filter((item: { customer: string; }) => item.customer === ColHeader);
              }
            break;
            case 1:
              rowData = this.customerDetailRows['customerMaxNotionalAmountData'].filter((item: { customer: string; }) => item.customer === ColHeader);
              if(!rowData.length) {
                rowData = this.customerDetailRows['customerMaxQuantityData'].filter((item: { customer: string; }) => item.customer === ColHeader);  
              }
            break;
          }
        break;
        case 'Trader':
          switch(rowIndex) {
            case 0:
              rowData = this.traderDetailRows['traderMaxQuantityData'].filter((item: { trader: string; }) => item.trader === ColHeader);
              if(!rowData.length) {
                rowData = this.traderDetailRows['traderMaxNotionalAmountData'].filter((item: { trader: string; }) => item.trader === ColHeader);
              }
            break;
            case 1:
              rowData = this.traderDetailRows['traderMaxNotionalAmountData'].filter((item: { trader: string; }) => item.trader === ColHeader);
              if(!rowData.length) {
                rowData = this.traderDetailRows['traderMaxQuantityData'].filter((item: { trader: string; }) => item.trader === ColHeader);
              }
            break;
          }
        break;
        case 'Price Deviation':
          switch(rowIndex) {
            case 0:
              rowData = this.maxPriceDeviationData[this.routeBuyField].filter((elemIndex: string) => (elemIndex===ColHeader));
            break;
            case 1:
              rowData = this.maxPriceDeviationData[this.routeSellField].filter((elemIndex: string) => (elemIndex===ColHeader));
            break;
            case 2:
              rowData = this.maxPriceDeviationData[this.orderBuyField].filter((elemIndex: string) => (elemIndex===ColHeader));
            break;
            case 3:
              rowData = this.maxPriceDeviationData[this.orderSellField].filter((elemIndex: string) => (elemIndex===ColHeader));
            break;
          }
        break;
      }

      if(rowData.length > 0) {
        this.dataService.roeSelectedRecords = [];
        this.dataService.roeSelectedRecords[0] = (rowData);
        this.view = true;
        this.rowDataforDialog = rowData;
        this.rowIndexForDialog = rowIndex;
        this.actionType = value;
      }
    }
  }

  changePage(event: any) {
    this.startLimit = event.first;
    this.endLimit = this.startLimit + this.rowcount;
    this.rowcount = event.rows;

    if (this.endLimit > this.totalRecords) {
      this.endLimit = this.totalRecords;
    }
    this.Limit = { 'Start': this.startLimit, 'End': this.rowcount };
    this.priviousStartLimit = this.startLimit;
    this.pageNumber = Math.round(this.startLimit / this.rowcount) + 1;
    this.getData();
  }

  closeDialog(value: any) {
    if (value) {
      this.dataService.roeSelectedRecords = [];
      this.getData()
    }
    this.view = false;
  }

  getData() {
    this.previousLimit = this.Limit;
    this.dataset = [];
    this.selectedRow = new MarketAccess();
    this.isLoadingResults = true;
    if(this.isApiRecalling) {
      this.isLoadingDestinationResults = true;
      this.isLoadingCustomerResults = true;
      this.isLoadingTraderResults = true;
      this.isLoadingPriceDeviationResults = true;
      this.isLoadingMaxOrderQty30DayAdvResults = true;
      this.isLoadingGrossNotionalResults = true;
    }

    this.tbldatamsg = "L o a d i n g . . . . .";
    const filterData = JSON.parse(JSON.stringify(this.defaultFilterArray));
    filterData[0].values[0] = this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[0])));
    filterData[0].values[1] = this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[1])));

    let payload = {
      data: filterData,
      mpid: this.userService.getActiveMPID(),
      recordType: this.recordSummaryType,
      startLimit: this.Limit.Start.toString(),
      endLimit: this.Limit.End.toString(),
      pageName: "Market Access Analysis"
    }

    this.sharedHttpClientService.post(
      this.urlsService.setAPIURl(
        APIURL.Market_Access
      ), payload
    ).subscribe({
      next: (Element:any) => {
        let dataset: any = Element;
        this.dataset = dataset.Data;
        this.totalRecords = dataset.totalCount;
        if(this.totalRecords == 0) {
          this.totalRecords = 1;
        }
        if (this.dataset.length == 0) {
          this.tbldatamsg = "No data found";
        }
        /* Retrieving Destination|Customer|Trader|Gross Notional */
        if(this.isApiRecalling) {
          this.getDestinations(filterData);
          this.getCustomers(filterData);
          this.getTraders(filterData);
          this.getPriceDeviations(filterData);
          this.getMaxOrderQty30DayAdv(filterData);
          this.getDailyGrossNotional(filterData);
        }
        this.isLoadingResults = false;
        /* End of retrieving Destination|Customer|Trader|Gross Notional */
      }, error: (err: HttpErrorResponse) => {
        this.isLoadingResults = false;
    }});
  }

  sort(event: any) {
    if(this.sortClickCounter !== 3 && (this.sortData.field === "" || this.sortData.field === event.multisortmeta[0].field)) {
      this.sortClickCounter = this.sortClickCounter + 1;
    } else {
      this.sortClickCounter = 1;
    }
    if(this.sortClickCounter !== 3) {
      let sortOrder = event.multisortmeta[0].order === 1 ? 'asc' : 'desc';
      this.sortData.field = event.multisortmeta[0].field;
      this.sortData.order = sortOrder;
      this.dataset = this.sortPipe.transform(this.dataset, this.sortData.order, this.sortData.field);
    } else {
      if((this.dt.multiSortMeta !== null && this.dt.multiSortMeta !== undefined)) {
        this.dt.multiSortMeta[0].field = '';
        this.dt.multiSortMeta[0].order = 0;
      }
    }
    
  }

  getDefaultValues(tblType: string) {
    switch(tblType) {
      case "Destination":
        this.frozenCols = [{ field: 'Destination', header: 'Destination' }];
        this.scrollableCols = [];
        for(let i = 1; i <= 10; i++) {
          this.scrollableCols.push({ field: 'Destination ' + i, header: 'Destination ' + i });
          this.destinationDetail[0]['Destination ' + i] = 0;
          this.destinationDetail[1]['Destination ' + i] = (0).toLocaleString("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 0, maximumFractionDigits: 0 });
        }
      break;
      case "Customer":
        this.frozenCustomerCols = [{ field: 'Customer', header: 'Customer' }];
        this.scrollableCustomerCols = [];
        for(let i = 1; i <= 10; i++) {
          this.scrollableCustomerCols.push({ field: 'Customer ' + i, header: 'Customer ' + i });
          this.customerDetail[0]['Customer ' + i] = 0;
          this.customerDetail[1]['Customer ' + i] = (0).toLocaleString("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 0, maximumFractionDigits: 0 });
      }
      break;
      case "Trader":
        this.frozenTraderCols = [{ field: 'Trader', header: 'Trader' }];
        this.scrollableTraderCols = [];
        for(let i = 1; i <= 10; i++) {
          this.scrollableTraderCols.push({ field: 'Trader ' + i, header: 'Trader ' + i });
          this.traderDetail[0]['Trader ' + i] = 0;
          this.traderDetail[1]['Trader ' + i] = (0).toLocaleString("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 0, maximumFractionDigits: 0 });
        }
      break;
      case "Price Deviation":
        this.frozenPriceDeviationCols = this.frozenPriceDeviationCols = [{ field: 'Route', header: '' }, { field: 'Orders', header: '' }];
        this.scrollablePriceDeviationCols = [];
        for(let i = 2; i <= 10; i++) {
          this.scrollablePriceDeviationCols.push({ field: 'Price_Deviation ' + i, header: '' });
          this.priceDeviationDetail[0]['Price_Deviation ' + i] = Number.parseFloat('0') + '%';
          this.priceDeviationDetail[1]['Price_Deviation ' + i] = Number.parseFloat('0') + '%';
          this.priceDeviationDetail[2]['Price_Deviation ' + i] = Number.parseFloat('0') + '%';
          this.priceDeviationDetail[3]['Price_Deviation ' + i] = Number.parseFloat('0') + '%';
        }
      break;
      case "Gross Notional":
        this.frozenNotionalCols = [{ field: 'Gross_Notional', header: 'Customer' }];
        this.scrollableNotionalCols = [];
        for(let i = 1; i <= 10; i++) {
          this.scrollableNotionalCols.push({ field: 'Gross_Notional ' + i, header: 'Customer ' + i });
          this.grossNotionalDetail[0]['Gross_Notional ' + i] = (0).toLocaleString("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 0, maximumFractionDigits: 0 });
          this.grossNotionalDetail[1]['Gross_Notional ' + i] = (0).toLocaleString("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 0, maximumFractionDigits: 0 });
          this.grossNotionalDetail[2]['Gross_Notional ' + i] = (0).toLocaleString("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 0, maximumFractionDigits: 0 });
          this.grossNotionalDetail[3]['Gross_Notional ' + i] = (0).toLocaleString("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 0, maximumFractionDigits: 0 });
        }
      break;
      case "Maximum Order Quantity 30 Day ADV":
        this.frozenMaxOrderSymbolQtyCols = [{ field: 'Symbol', header: 'Symbol' }];
        this.scrollableMaxOrderSymbolQtyCols = [];
        for(let i = 1; i <= 10; i++) {
          this.scrollableMaxOrderSymbolQtyCols.push({ field: 'Symbol ' + i, header: 'Symbol ' + i });
          this.maxSymbolOrderQtyDetail[0]['Symbol ' + i] = 0;
        }
      break;
    }
  }

  getDestinations(filterData: any[]) {
    this.isLoadingDestinationResults = true;

    this.sharedHttpClientService.post(
      this.urlsService.setAPIURl(APIURL.Destination_Detail_List), 
      { data: filterData, mpid: this.userService.getActiveMPID() }
    ).subscribe({
      next: (Element:any) => {
        this.destinationDetailRows = Element;

        this.maxQtyData = [];
        for(let i=0; i<this.destinationDetailRows.maxQuantityData.length; i++) {
          let identifiedRecord = 0;
          for(let j=0; j<this.destinationDetailRows.maxNotionalAmountData.length; j++) {
            if(this.destinationDetailRows.maxQuantityData[i].destination === this.destinationDetailRows.maxNotionalAmountData[j].destination) {
              identifiedRecord = 1;
              this.maxQtyData.push({destination: this.destinationDetailRows.maxQuantityData[i].destination, quantity: (!this.destinationDetailRows.maxQuantityData[i].routeQuantity ? (!this.destinationDetailRows.maxNotionalAmountData[j].routeQuantity ? 0 : this.destinationDetailRows.maxNotionalAmountData[j].routeQuantity) : this.destinationDetailRows.maxQuantityData[i].routeQuantity), notionalamount: this.destinationDetailRows.maxNotionalAmountData[j].total});
            }
          }
          if(identifiedRecord === 0) {
            let orderNotionalAmt = 0;
            if(this.destinationDetailRows.maxQuantityData[i].routePrice > 0) {
              orderNotionalAmt = (this.destinationDetailRows.maxQuantityData[i].routeQuantity * this.destinationDetailRows.maxQuantityData[i].routePrice);
            } else {
              let routePrice = (this.destinationDetailRows.maxQuantityData[i].side === 'SL' ? this.destinationDetailRows.maxQuantityData[i].routeBidPrice : (this.destinationDetailRows.maxQuantityData[i].side === 'B' ? this.destinationDetailRows.maxQuantityData[i].routeAskPrice : 1));
              orderNotionalAmt = (this.destinationDetailRows.maxQuantityData[i].routeQuantity * routePrice);
            }
            this.maxQtyData.push({destination: this.destinationDetailRows.maxQuantityData[i].destination, quantity: (!this.destinationDetailRows.maxQuantityData[i].routeQuantity ? 0 : this.destinationDetailRows.maxQuantityData[i].routeQuantity), notionalamount: orderNotionalAmt});
          }
        }

        for(let i=0; i<this.destinationDetailRows.maxNotionalAmountData.length; i++) {
          let identifiedRecord = 0;
          for(let j=0; j<this.maxQtyData.length; j++) {
            if(this.destinationDetailRows.maxNotionalAmountData[i].destination === this.maxQtyData[j].destination) {
              identifiedRecord = 1;
            }
          }
          if(identifiedRecord === 0) {
            this.maxQtyData.push({destination: this.destinationDetailRows.maxNotionalAmountData[i].destination, quantity: this.destinationDetailRows.maxNotionalAmountData[i].routeQuantity, notionalamount: this.destinationDetailRows.maxNotionalAmountData[i].total});
          }
        }

        if(this.maxQtyData.length > 0) {
          this.frozenCols = [{ field: 'Destination', header: 'Destination (' + this.maxQtyData.length + ')' }];
          this.scrollableCols = [];
          this.maxQtyData = _.orderBy(this.maxQtyData, [this.qtyField], [this.destinationQtyFieldSortOrder as boolean |"asc"|"desc"]);
          for(let i=0; i<this.maxQtyData.length; i++) {
            this.scrollableCols.push({ field: 'Destination ' + i, header: this.maxQtyData[i].destination.substring(this.maxQtyData[i].destination.indexOf(":")+1) });
            this.destinationDetail[0]['Destination ' + i] = this.maxQtyData[i].quantity.toLocaleString("en-US");
            this.destinationDetail[1]['Destination ' + i] = this.maxQtyData[i].notionalamount.toLocaleString("en", { style: "currency", currency: "USD", minimumFractionDigits: 0, maximumFractionDigits: 0 });
          }
        } else if (this.maxQtyData.length === 0) {
          this.getDefaultValues('Destination');
        }
        /* MultiSelect Destinations */
        this.optedDestinations = this.scrollableCols;
        this.isLoadingDestinationResults = false;
      }, error: (err: HttpErrorResponse) => {
        this.isLoadingDestinationResults = false;
    }});
  }

  getCustomers(filterData: any[]) {
    this.isLoadingCustomerResults = true;

    this.sharedHttpClientService.post(
      this.urlsService.setAPIURl(APIURL.Customer_Detail_List), 
      { data: filterData, mpid: this.userService.getActiveMPID() }
    ).subscribe({
      next: (customerElement:any) => {
        this.customerDetailRows = customerElement;
        this.customerMaxQtyData = [];
        for(let i=0; i<this.customerDetailRows.customerMaxQuantityData.length; i++) {
          let identifiedRecord = 0;
          for(let j=0; j<this.customerDetailRows.customerMaxNotionalAmountData.length; j++) {
            if(this.customerDetailRows.customerMaxQuantityData[i].customer === this.customerDetailRows.customerMaxNotionalAmountData[j].customer) {
              identifiedRecord = 1;
              this.customerMaxQtyData.push({customer: this.customerDetailRows.customerMaxQuantityData[i].customer, quantity: this.customerDetailRows.customerMaxQuantityData[i].maxQty, notionalamount: this.customerDetailRows.customerMaxNotionalAmountData[j].total});
            }
          }
          if(identifiedRecord === 0) {
            let orderNotionalAmt = 0;
            if(this.customerDetailRows.customerMaxQuantityData[i].orderPrice > 0) {
              orderNotionalAmt = (this.customerDetailRows.customerMaxQuantityData[i].orderQuantity * this.customerDetailRows.customerMaxQuantityData[i].orderPrice);
            } else {
              let routePrice = (this.customerDetailRows.customerMaxQuantityData[i].side === 'SL' ? this.customerDetailRows.customerMaxQuantityData[i].routeBidPrice : (this.customerDetailRows.customerMaxQuantityData[i].side === 'B' ? this.customerDetailRows.customerMaxQuantityData[i].routeAskPrice : 1));
              orderNotionalAmt = (this.customerDetailRows.customerMaxQuantityData[i].routeQuantity * routePrice);
            }
            this.customerMaxQtyData.push({customer: this.customerDetailRows.customerMaxQuantityData[i].customer, quantity: this.customerDetailRows.customerMaxQuantityData[i].maxQty, notionalamount: orderNotionalAmt});
          }
        }

        for(let i=0; i<this.customerDetailRows.customerMaxNotionalAmountData.length; i++) {
          let identifiedRecord = 0;
          for(let j=0; j<this.customerMaxQtyData.length; j++) {
            if(this.customerDetailRows.customerMaxNotionalAmountData[i].customer === this.customerMaxQtyData[j].customer) {
              identifiedRecord = 1;
            }
          }
          if(identifiedRecord === 0) {
            this.customerMaxQtyData.push({customer: this.customerDetailRows.customerMaxNotionalAmountData[i].customer, quantity: this.customerDetailRows.customerMaxNotionalAmountData[i].routeQuantity, notionalamount: this.customerDetailRows.customerMaxNotionalAmountData[i].total});
          }
        }

        if(this.customerMaxQtyData.length > 0) {
          this.frozenCustomerCols = [{ field: 'Customer', header: 'Customer (' + this.customerMaxQtyData.length + ')' }];
          this.scrollableCustomerCols = [];
          this.customerMaxQtyData = _.orderBy(this.customerMaxQtyData, [this.qtyField], [this.customerQtyFieldSortOrder as boolean |"asc"|"desc"]);
          for(let i=0; i<this.customerMaxQtyData.length; i++) {
            this.scrollableCustomerCols.push({ field: 'Customer ' + i, header: this.customerMaxQtyData[i].customer });
            this.customerDetail[0]['Customer ' + i] = this.customerMaxQtyData[i].quantity.toLocaleString("en-US");
            this.customerDetail[1]['Customer ' + i] = this.customerMaxQtyData[i].notionalamount.toLocaleString("en", { style: "currency", currency: "USD", minimumFractionDigits: 0, maximumFractionDigits: 0 });
          }
        } else if (this.customerMaxQtyData.length === 0) {
          this.getDefaultValues('Customer');
        }
        this.isLoadingCustomerResults = false;
        /* MultiSelect Customers */
        this.optedCustomers = this.scrollableCustomerCols;
      }, error: (err: HttpErrorResponse) => {
        this.isLoadingCustomerResults = false;
    }});
  }

  getTraders(filterData: any[]) {
    this.isLoadingTraderResults = true;

    this.sharedHttpClientService.post(
      this.urlsService.setAPIURl(APIURL.Trader_Detail_List), 
      { data: filterData, mpid: this.userService.getActiveMPID() }
    ).subscribe({
      next: (TraderElement:any) => {
        this.traderDetailRows = TraderElement;

        this.traderMaxQtyData = [];
        for(let i=0; i<this.traderDetailRows.traderMaxQuantityData.length; i++) {
          let identifiedRecord = 0;
          for(let j=0; j<this.traderDetailRows.traderMaxNotionalAmountData.length; j++) {
            if(this.traderDetailRows.traderMaxQuantityData[i].trader === this.traderDetailRows.traderMaxNotionalAmountData[j].trader) {
              identifiedRecord = 1;
              this.traderMaxQtyData.push({trader: this.traderDetailRows.traderMaxQuantityData[i].trader, quantity: this.traderDetailRows.traderMaxQuantityData[i].maxQty, notionalamount: this.traderDetailRows.traderMaxNotionalAmountData[j].total});
            }
          }
          if(identifiedRecord === 0) {
            let orderNotionalAmt = 0;
            if(this.traderDetailRows.traderMaxQuantityData[i].orderPrice > 0) {
              orderNotionalAmt = (this.traderDetailRows.traderMaxQuantityData[i].orderQuantity * this.traderDetailRows.traderMaxQuantityData[i].orderPrice);
            } else {
              let routePrice = (this.traderDetailRows.traderMaxQuantityData[i].side === 'SL' ? this.traderDetailRows.traderMaxQuantityData[i].routeBidPrice : (this.traderDetailRows.traderMaxQuantityData[i].side === 'B' ? this.traderDetailRows.traderMaxQuantityData[i].routeAskPrice : 1));
              orderNotionalAmt = (this.traderDetailRows.traderMaxQuantityData[i].routeQuantity * routePrice);
            }
            this.traderMaxQtyData.push({trader: this.traderDetailRows.traderMaxQuantityData[i].trader, quantity: this.traderDetailRows.traderMaxQuantityData[i].maxQty, notionalamount: orderNotionalAmt});
          }
        }

        for(let i=0; i<this.traderDetailRows.traderMaxNotionalAmountData.length; i++) {
          let identifiedRecord = 0;
          for(let j=0; j<this.traderMaxQtyData.length; j++) {
            if(this.traderDetailRows.traderMaxNotionalAmountData[i].trader === this.traderMaxQtyData[j].trader) {
              identifiedRecord = 1;
            }
          }
          if(identifiedRecord === 0) {
            this.traderMaxQtyData.push({trader: this.traderDetailRows.traderMaxNotionalAmountData[i].trader, quantity: this.traderDetailRows.traderMaxNotionalAmountData[i].routeQuantity, notionalamount: this.traderDetailRows.traderMaxNotionalAmountData[i].total});
          }
        }

        if(this.traderMaxQtyData.length > 0) {
          this.frozenTraderCols = [{ field: 'Trader', header: 'Trader (' + this.traderMaxQtyData.length + ')' }];
          this.scrollableTraderCols = [];
          this.traderMaxQtyData = _.orderBy(this.traderMaxQtyData, [this.qtyField], [this.traderQtyFieldSortOrder as boolean |"asc"|"desc"]);
          for(let i=0; i<this.traderMaxQtyData.length; i++) {
            this.scrollableTraderCols.push({ field: 'Trader ' + i, header: this.traderMaxQtyData[i].trader });
            this.traderDetail[0]['Trader ' + i] = this.traderMaxQtyData[i].quantity.toLocaleString("en-US");
            this.traderDetail[1]['Trader ' + i] = this.traderMaxQtyData[i].notionalamount.toLocaleString("en", { style: "currency", currency: "USD", minimumFractionDigits: 0, maximumFractionDigits: 0 });
          }
        } else if(this.traderMaxQtyData.length === 0) {
          this.getDefaultValues('Trader');
        }
        this.isLoadingTraderResults = false;
        /* MultiSelect Traders */
        this.optedTraders = this.scrollableTraderCols;
      }, error: (err: HttpErrorResponse) => {
        this.isLoadingTraderResults = false;
    }});
  }

  getPriceDeviations(filterData: any[]) {
    this.sharedHttpClientService.post(
      this.urlsService.setAPIURl(
        APIURL.Max_Price_Deviation
      ), { data: filterData, recordType: 3, mpid: this.userService.getActiveMPID() }
    ).subscribe({
      next: (Element:any) => {
        let resultSet: any = Element;
        this.maxPriceDeviationData = {};

        if(resultSet.priceDeviationData.length > 0) {
          this.maxPriceDeviationData[this.routeBuyField] = [];
          this.maxPriceDeviationData[this.routeSellField] = [];
          this.maxPriceDeviationData[this.orderBuyField] = [];
          this.maxPriceDeviationData[this.orderSellField] = [];
          for(let i=0; i<resultSet.priceDeviationData.length; i++) {
            if(resultSet.priceDeviationData[i].routeID && resultSet.priceDeviationData[i].side === 'B') {
              this.maxPriceDeviationData[this.routeBuyField].push(resultSet.priceDeviationData[i]);
            } else if(resultSet.priceDeviationData[i].routeID && resultSet.priceDeviationData[i].side === 'S') {
              this.maxPriceDeviationData[this.routeSellField].push(resultSet.priceDeviationData[i]);
            } else if(!resultSet.priceDeviationData[i].routeID && resultSet.priceDeviationData[i].side === 'B') {
              this.maxPriceDeviationData[this.orderBuyField].push(resultSet.priceDeviationData[i]);
            } else if(!resultSet.priceDeviationData[i].routeID && resultSet.priceDeviationData[i].side === 'S') {
              this.maxPriceDeviationData[this.orderSellField].push(resultSet.priceDeviationData[i]);
            }
          }
        }

        if(Object.keys(this.maxPriceDeviationData).length > 0) {
          this.frozenPriceDeviationCols = [{ field: 'Route', header: '' }, { field: 'Orders', header: '' }];
          this.scrollablePriceDeviationCols = [];
          this.maxPriceDeviationData[this.routeBuyField] = _.orderBy(this.maxPriceDeviationData[this.routeBuyField], [this.PDPercentage], [this.routeBuyFieldSortOrder as boolean |"asc"|"desc"]);

          let maxLength = [this.maxPriceDeviationData[this.routeBuyField].length, this.maxPriceDeviationData[this.routeSellField].length, this.maxPriceDeviationData[this.orderBuyField].length, this.maxPriceDeviationData[this.orderSellField].length];
          for(let i=0; i<Math.max(...maxLength); i++) {
            this.scrollablePriceDeviationCols.push({ field: 'Price_Deviation ' + i, header: '' });
            this.priceDeviationDetail[0]['Price_Deviation ' + i] = Number.parseFloat(this.maxPriceDeviationData[this.routeBuyField][i] && this.maxPriceDeviationData[this.routeBuyField][i][this.PDPercentage] ? this.maxPriceDeviationData[this.routeBuyField][i][this.PDPercentage] : 0) + '%';
            this.priceDeviationDetail[1]['Price_Deviation ' + i] = Number.parseFloat(this.maxPriceDeviationData[this.routeSellField][i] && this.maxPriceDeviationData[this.routeSellField][i][this.PDPercentage] ? this.maxPriceDeviationData[this.routeSellField][i][this.PDPercentage] : 0) + '%';
            this.priceDeviationDetail[2]['Price_Deviation ' + i] = Number.parseFloat(this.maxPriceDeviationData[this.orderBuyField][i] && this.maxPriceDeviationData[this.orderBuyField][i][this.PDPercentage] ? this.maxPriceDeviationData[this.orderBuyField][i][this.PDPercentage] : 0) + '%';
            this.priceDeviationDetail[3]['Price_Deviation ' + i] = Number.parseFloat(this.maxPriceDeviationData[this.orderSellField][i] && this.maxPriceDeviationData[this.orderSellField][i][this.PDPercentage] ? this.maxPriceDeviationData[this.orderSellField][i][this.PDPercentage] : 0) + '%';
          }
        } else if(Object.keys(this.maxPriceDeviationData).length === 0) {
          this.getDefaultValues('Price Deviation');
        }
        this.isLoadingPriceDeviationResults = false;
        this.isApiRecalling = false; // Restriction of APIs Recalling
      }, error: (err: HttpErrorResponse) => {
        this.isLoadingPriceDeviationResults = false;
    }});
  }

  getMaxOrderQty30DayAdv(filterData: any[]) {
    this.sharedHttpClientService.post(
      this.urlsService.setAPIURl(
        APIURL.Max_Order_Quantity_30_Day_ADV
      ), { data: filterData, mpid: this.userService.getActiveMPID() }
    ).subscribe({
      next: (Element:any) => {
        let resultSet: any = Element;
        this.maxSymbolOrderQtyData = [];
        this.maxSymbolOrderQtyData = resultSet.maxOrderQuantity30DayADVData;
        if(this.maxSymbolOrderQtyData.length > 0) {
          this.frozenMaxOrderSymbolQtyCols = [{ field: 'Symbol', header: 'Symbol'}];
          this.scrollableMaxOrderSymbolQtyCols = [];
          this.maxSymbolOrderQtyData = _.orderBy(this.maxSymbolOrderQtyData, [this.maxOrderQtyField], [this.maxOrderQtyFieldSortOrder]);

          for(let i=0; i<this.maxSymbolOrderQtyData.length; i++) {
            this.scrollableMaxOrderSymbolQtyCols.push({ field: 'Symbol ' + i, header: this.maxSymbolOrderQtyData[i]['Symbol'] });
            this.maxSymbolOrderQtyDetail[0]['Symbol ' + i] = this.maxSymbolOrderQtyData[i]['totalQuantities'].toLocaleString("en-US");
          }
        } else if(this.maxSymbolOrderQtyData.length === 0) {
          this.getDefaultValues('Maximum Order Quantity 30 Day ADV');
        }

        this.isLoadingMaxOrderQty30DayAdvResults = false;
        this.isApiRecalling = false; // Restriction of APIs Recalling
      }, error: (err: HttpErrorResponse) => {
        this.isLoadingMaxOrderQty30DayAdvResults = false;
    }});
  }

  getDailyGrossNotional(filterData: any[]) {
    this.sharedHttpClientService.post(
      this.urlsService.setAPIURl(
        APIURL.Max_Daily_Gross_Notional
      ), { data: filterData, mpid: this.userService.getActiveMPID() }
    ).subscribe({
      next: (Element:any) => {
        let resultSet: any = Element;
        this.maxGrossNotionalData = [];
        if(resultSet.openOrdersData.length > 0) {
          for(let i=0; i<resultSet.openOrdersData.length; i++) {
            let searchCustomerIndexed = this.maxGrossNotionalData.findIndex((elem) => elem.customer===resultSet.openOrdersData[i].customer);
            let executedOrder: any = {};
            for(let j=0; j<resultSet.executedOrdersData.length; j++) {
              if(resultSet.openOrdersData[i].customer === resultSet.executedOrdersData[j].ExecutionVenue) {
                if(resultSet.executedOrdersData[j].BuySellCode === 'B') {
                  executedOrder['buyExecuted'] = resultSet.executedOrdersData[j].grossNotionalAmt;
                } else if (resultSet.executedOrdersData[j].BuySellCode === 'S') {
                  executedOrder['sellExecuted'] = resultSet.executedOrdersData[j].grossNotionalAmt;
                }
              }
            }
            if(searchCustomerIndexed === -1) {
              if(resultSet.openOrdersData[i].BuySellCode === 'B') {
                this.maxGrossNotionalData.push({customer: resultSet.openOrdersData[i].customer, buyOpened: (resultSet.openOrdersData[i].grossNotionalAmt ? resultSet.openOrdersData[i].grossNotionalAmt : 0), sellOpened: 0, buyExecuted: (executedOrder['buyExecuted'] ? executedOrder['buyExecuted'] : 0), sellExecuted: (executedOrder['sellExecuted'] ? executedOrder['sellExecuted'] : 0)});
              } else if (resultSet.openOrdersData[i].BuySellCode === 'S') {
                this.maxGrossNotionalData.push({customer: resultSet.openOrdersData[i].customer, buyOpened: 0, sellOpened: (resultSet.openOrdersData[i].grossNotionalAmt ? resultSet.openOrdersData[i].grossNotionalAmt : 0), buyExecuted: (executedOrder['buyExecuted'] ? executedOrder['buyExecuted'] : 0), sellExecuted: (executedOrder['sellExecuted'] ? executedOrder['sellExecuted'] : 0)});
              }
            } else {
              if(resultSet.openOrdersData[i].BuySellCode === 'B') {
                this.maxGrossNotionalData[searchCustomerIndexed]['buyOpened'] = (resultSet.openOrdersData[i].grossNotionalAmt ? resultSet.openOrdersData[i].grossNotionalAmt : 0);
                this.maxGrossNotionalData[searchCustomerIndexed]['sellOpened'] = (this.maxGrossNotionalData[searchCustomerIndexed]['sellOpened'] ? this.maxGrossNotionalData[searchCustomerIndexed]['sellOpened'] : 0);
                this.maxGrossNotionalData[searchCustomerIndexed]['buyExecuted'] = !this.maxGrossNotionalData[searchCustomerIndexed]['buyExecuted'] ? (executedOrder['buyExecuted'] ? executedOrder['buyExecuted'] : 0) : this.maxGrossNotionalData[searchCustomerIndexed]['buyExecuted'];
                this.maxGrossNotionalData[searchCustomerIndexed]['sellExecuted'] = !this.maxGrossNotionalData[searchCustomerIndexed]['sellExecuted'] ? (executedOrder['sellExecuted'] ? executedOrder['sellExecuted'] : 0) : this.maxGrossNotionalData[searchCustomerIndexed]['sellExecuted'];
              } else if (resultSet.openOrdersData[i].BuySellCode === 'S') {
                this.maxGrossNotionalData[searchCustomerIndexed]['buyOpened'] = (this.maxGrossNotionalData[searchCustomerIndexed]['buyOpened'] ? this.maxGrossNotionalData[searchCustomerIndexed]['buyOpened'] : 0);
                this.maxGrossNotionalData[searchCustomerIndexed]['sellOpened'] = (resultSet.openOrdersData[i].grossNotionalAmt ? resultSet.openOrdersData[i].grossNotionalAmt : 0);
                this.maxGrossNotionalData[searchCustomerIndexed]['buyExecuted'] = !this.maxGrossNotionalData[searchCustomerIndexed]['buyExecuted'] ? (executedOrder['buyExecuted'] ? executedOrder['buyExecuted'] : 0) : this.maxGrossNotionalData[searchCustomerIndexed]['buyExecuted'];
                this.maxGrossNotionalData[searchCustomerIndexed]['sellExecuted'] = !this.maxGrossNotionalData[searchCustomerIndexed]['sellExecuted'] ? (executedOrder['sellExecuted'] ? executedOrder['sellExecuted'] : 0) : this.maxGrossNotionalData[searchCustomerIndexed]['sellExecuted'];
              }
            }
          }
        }

        if(this.maxGrossNotionalData.length > 0) {
          this.frozenNotionalCols = [{ field: 'Gross_Notional', header: 'Customer (' + this.maxGrossNotionalData.length + ')' }];
          this.scrollableNotionalCols = [];
          this.maxGrossNotionalData = _.orderBy(this.maxGrossNotionalData, [this.notionalBuyOpenField], [this.notionalBuyOpenFieldSortOrder as boolean |"asc"|"desc"]);
          for(let i=0; i<this.maxGrossNotionalData.length; i++) {
            this.scrollableNotionalCols.push({ field: 'Gross_Notional ' + i, header: this.maxGrossNotionalData[i].customer });
            this.grossNotionalDetail[0]['Gross_Notional ' + i] = (this.maxGrossNotionalData[i].buyOpened ? this.maxGrossNotionalData[i].buyOpened : 0).toLocaleString("en", { style: "currency", currency: "USD", minimumFractionDigits: 0, maximumFractionDigits: 0 });
            this.grossNotionalDetail[1]['Gross_Notional ' + i] = (this.maxGrossNotionalData[i].sellOpened ? this.maxGrossNotionalData[i].sellOpened : 0).toLocaleString("en", { style: "currency", currency: "USD", minimumFractionDigits: 0, maximumFractionDigits: 0 });
            this.grossNotionalDetail[2]['Gross_Notional ' + i] = (this.maxGrossNotionalData[i].buyExecuted ? this.maxGrossNotionalData[i].buyExecuted : 0).toLocaleString("en", { style: "currency", currency: "USD", minimumFractionDigits: 0, maximumFractionDigits: 0 });
            this.grossNotionalDetail[3]['Gross_Notional ' + i] = (this.maxGrossNotionalData[i].sellExecuted ? this.maxGrossNotionalData[i].sellExecuted : 0).toLocaleString("en", { style: "currency", currency: "USD", minimumFractionDigits: 0, maximumFractionDigits: 0 });
          }
        } else if(this.maxGrossNotionalData.length === 0) {
          this.getDefaultValues('Gross Notional');
        }
        this.isLoadingGrossNotionalResults = false;
        this.isApiRecalling = false; // Restriction of APIs Recalling
      }, error: (err: HttpErrorResponse) => {
        this.isLoadingGrossNotionalResults = false;
    }});
  }

  defaultFilter() {
    let date = new Date();

      this.LastExecutionDate = [];
      this.LastExecutionDate.push(date); // FromDate
      this.LastExecutionDate.push(date); // Todate

      this.defaultFilterArray = [
      {'isdefault': 'true', 'label': 'Date', 'columnname': 'reportDate', 'filterby': 'IS', 'values': this.LastExecutionDate, 'time': '', 'datatype': 'DateRange', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': ''},
      {'isdefault': 'true', 'label': 'Order Date', 'columnname': 'orderDate', 'filterby': 'IS', 'values': this.orderDateRange, 'time': '', 'datatype': 'DateRange', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': ''},
      {'isdefault': 'true', 'label': 'Route Date', 'columnname': 'routeDate', 'filterby': 'IS', 'values': this.routeDateRange, 'time': '', 'datatype': 'DateRange', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': ''},
      {'isdefault': 'true', 'label': 'Symbol', 'columnname': 'symbol', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': ''},
      {'isdefault': 'true', 'label': 'Order ID', 'columnname': 'orderID', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': ''},
      {'isdefault': 'true', 'label': 'Route ID', 'columnname': 'routeID', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': ''},
      {'isdefault': 'true', 'label': 'OMS Order ID', 'columnname': 'OMSOrderID', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': ''},
      {'isdefault': 'true', 'label': 'Destination', 'columnname': 'destination', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': ''},
      {'isdefault': 'true', 'label': 'Customer', 'columnname': 'customer', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': ''},
      {'isdefault': 'true', 'label': 'Trader', 'columnname': 'trader', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': ''}
    ]
  }

  filterApplyFilterEvent(event: any) {
    this.defaultFilterArray = [];
    this.defaultFilterArray = event;
    this.startLimit = 0;
    this.Limit.Start = 0;

    this.pageNumber = 1;
    this.dt.first = this.startLimit;
    this.isApiRecalling = true; // Removal restriction of APIs Recalling
    this.getData();
  }

  onShowOrderViewer(rowData: any, rowIndex: any) {

    this.emitterService.isOrderViewerOpenCloseEvent.emit(
      {
        display: true,
        rowData: rowData,
        pageName: 'CAT-ROE'
      });
  }

  exportToCSV(event: any) {
    let initialTime = new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit'});
    let exportLimt: any;
    if (event.isExport5000Rows) {
      exportLimt = { 'Start': this.constantService.NUMBER_0, 'End': this.constantService.NUMBER_MAX_EXPORT_ROWS };
    } else {
      exportLimt = this.previousLimit;
    }
    let payload = {
      data: this.defaultFilterArray,
      mpid: this.userService.getActiveMPID(),
      recordType: this.recordSummaryType,
      startLimit: exportLimt.Start.toString(),
      endLimit: exportLimt.End.toString(),
      pageName: "Market Access Analysis"
    }
    this.sharedHttpClientService.post(
      this.urlsService.setAPIURl(
        APIURL.Market_Access
      ),
      payload
    ).subscribe({
      next: (Element:any) => {
        let dataset: any = Element;
        dataset = dataset.Data;
      if (dataset.length > 0) {
        const options: any = {
          fieldSeparator: ',',
          quoteStrings: '"',
          decimalSeparator: '.',
          showLabels: true,
          showTitle: true,
          title: 'RSMS_Survillance_Market_Access_' + this.userService.getyyyyMMddDateFormate(new Date()),
          useTextFile: false,
          useBom: true,
          useKeysAsHeaders: true,
          // header: ['col 1', 'col 2'] // Won't work with useKeysAsHeaders present!
          filename: this.userService.getActiveMPID() +'_RSMS_Survillance_Market_Access_' + this.userService.getyyyyMMdd_HH_MM_SSDateFormate(new Date()),
        };
        const csvData = this.constantService.getExportData(dataset, event.gridColumn);
        const csv = generateCsv(options)(csvData);
        const blob = asBlob(options)(csv);
        saveAs(blob,options.filename);

        this.userService.logUserActivity('Export CSV', null, {
          'Text1': 'File Download Successfully | ' + (dataset.length > 0 ? dataset.length : 0) + ' records downloaded with file name: ' + options.filename + ' with start time: ' + initialTime + ' and end time: ' + new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit'}),
          'Text2': 'User Filter Parameters: ' + JSON.stringify(this.defaultFilterArray.filter((filterParam: { values: string | any[]; }) => (filterParam.values != '' || filterParam.values.length > 0)))
        });
      } else {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'No data found' });
        this.userService.logUserActivity('Export CSV', null, {
          'Text1': 'No data found',
          'Text2': 'User Filter Parameters: ' + JSON.stringify(this.defaultFilterArray.filter((filterParam: { values: string | any[]; }) => (filterParam.values != '' || filterParam.values.length > 0)))
        });
      }
      this.emitterService.exportToCSVData.emit(true);

    }, error: (err: HttpErrorResponse) => {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error while Exporting' });
      this.userService.logUserActivity('Export CSV', null, {
        'Text1': 'Error while Exporting',
        'Text2': 'User Filter Parameters: ' + JSON.stringify(this.defaultFilterArray.filter((filterParam: { values: string | any[]; }) => (filterParam.values != '' || filterParam.values.length > 0)))
      });
    }});
  }

}